import FormInput from '../components/formInput/formInput'
import CustomerProfileService from '../services/customerProfile/customerProfileService'

const customerProfileHelper = {
  getCustomerProfile: async function (context, auth) {
    const isSignedIn = auth?.identity?.isSignedIn
    const authorizationHeader = auth?.identity?.authorizationHeader
    const customerProfileService = new CustomerProfileService()

    if (authorizationHeader && !!isSignedIn) {
      const customerProfile = await customerProfileService.getCustomerProfile(authorizationHeader)
      if (customerProfile != null) {
        context.setState({
          email: new FormInput(customerProfile.email),
          firstName: new FormInput(customerProfile.firstName),
          lastName: new FormInput(customerProfile.lastName),
        })
      }
    }
  },
}

export default customerProfileHelper
